/** @format */

import { Component, Input, inject } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import { IonItem, IonLabel, IonList, IonListHeader, IonRadio, IonRadioGroup } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { BaseFormComponent } from '../base-form.component';

@Component({
    selector: 'fs-form-radio',
    templateUrl: './form-radio.component.html',
    styleUrls: ['./form-radio.component.scss'],
    standalone: true,
    imports: [KeyValuePipe, IonList, IonRadioGroup, IonListHeader, IonLabel, IonItem, IonRadio]
})
export class FormRadioComponent extends BaseFormComponent {
  @Input() values: Record<string, { title: string; description: string }>;
  @Input() header: string;

  constructor() {
    const translate = inject(TranslateService);

    super(translate);
  }

  /** keep original order, use keyvalue:onCompare */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public keepOriginalOrder = (a, b) => a.key;
}
